import blockedVisitorSlice, {
  ListBlock,
  blockHistorySelector,
  inputSearchSelector as inputSearchBlockedSelector,
} from '@/redux/slice/blockedVisitor.slice';
import visitorLogSlice, { ListVisitors, inputSearchSelector, visitorLogSelector } from '@/redux/slice/visitorAnalytics.slice';
import _debounce from 'lodash/debounce';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Filters from './Filters';
import { useTranslation } from 'react-i18next';

const useConfigTable = () => {
  const { t } = useTranslation(['visitor_analytics', 'common']);
  const dispatch = useDispatch();

  const visitorLogTable = useSelector(visitorLogSelector);
  const inputSearchVisitorLog = useSelector(inputSearchSelector);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSetSearchVisitorLog = useCallback(
    _debounce((value: ListVisitors) => {
      dispatch(visitorLogSlice.actions.handleVisitorLogTable(value));
    }, 1000),
    [],
  );
  const onSearchChange = (value: string) => {
    dispatch(visitorLogSlice.actions.handleInputSearch(value));
    debounceSetSearchVisitorLog({
      ...visitorLogTable,
      search: value,
      page: 1,
    });
  };
  const visitorLog = {
    sortOptions: [
      { label: t('visitor_analytics:total_access'), value: 'totalAccess asc', directionLabel: t('common:ascending') },
      { label: t('visitor_analytics:total_access'), value: 'totalAccess desc', directionLabel: t('common:descending') },
      { label: t('visitor_analytics:last_seen_on'), value: 'lastSeenOn asc', directionLabel: t('common:ascending') },
      { label: t('visitor_analytics:last_seen_on'), value: 'lastSeenOn desc', directionLabel: t('common:descending') },
    ],
    sortSelected: [`${visitorLogTable.sortBy} ${visitorLogTable.sort}`],
    queryValue: inputSearchVisitorLog,
    onClearAll: () => {
      dispatch(visitorLogSlice.actions.handlePerPage('10'));
      dispatch(
        visitorLogSlice.actions.handleVisitorLogTable({
          ...visitorLogTable,
          page: 1,
          status: undefined,
          risk: undefined,
          countriesCode: undefined,
          providers: undefined,
          locations: undefined,
        }),
      );
    },
    onQueryChange: onSearchChange,
    onQueryClear: () => onSearchChange(''),
    onSort: (value: string[]) => {
      const data = value[0].split(' ');
      dispatch(
        visitorLogSlice.actions.handleVisitorLogTable({
          ...visitorLogTable,
          sortBy: data[0],
          sort: data[1],
        }),
      );
    },
    queryPlaceholder: t('visitor_analytics:search_by_ip_details'),
    filters: Filters().visitors.filters,
    appliedFilters: Filters().visitors.appliedFilters.filter((item) => !item.hidden),
  };

  // Blocked
  const blockHistoryTable = useSelector(blockHistorySelector);
  const inputSearchBlocked = useSelector(inputSearchBlockedSelector);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSetSearchBlocked = useCallback(
    _debounce((value: ListBlock) => {
      dispatch(blockedVisitorSlice.actions.handleBlockHistoryTable(value));
    }, 1000),
    [],
  );
  const onSearchBlockedChange = (value: string) => {
    dispatch(blockedVisitorSlice.actions.handleInputSearch(value));
    debounceSetSearchBlocked({
      ...blockHistoryTable,
      search: value,
      page: 1,
    });
  };
  const blocked = {
    sortOptions: [
      { label: t('visitor_analytics:total_access'), value: 'totalAccess asc', directionLabel: t('common:ascending') },
      { label: t('visitor_analytics:total_access'), value: 'totalAccess desc', directionLabel: t('common:descending') },
      { label: t('visitor_analytics:last_seen_on'), value: 'lastSeenOn asc', directionLabel: t('common:ascending') },
      { label: t('visitor_analytics:last_seen_on'), value: 'lastSeenOn desc', directionLabel: t('common:descending') },
    ],
    sortSelected: [`${blockHistoryTable.sortBy} ${blockHistoryTable.sort}`],
    queryValue: inputSearchBlocked,
    onClearAll: () => {
      dispatch(visitorLogSlice.actions.handlePerPage('10'));
      dispatch(
        blockedVisitorSlice.actions.handleBlockHistoryTable({
          ...blockHistoryTable,
          risk: undefined,
          countriesCode: undefined,
          providers: undefined,
          locations: undefined,
        }),
      );
    },
    onQueryChange: onSearchBlockedChange,
    onQueryClear: () => onSearchBlockedChange(''),
    onSort: (value: string[]) => {
      const data = value[0].split(' ');
      dispatch(
        blockedVisitorSlice.actions.handleBlockHistoryTable({
          ...visitorLogTable,
          sortBy: data[0],
          sort: data[1],
        }),
      );
    },
    queryPlaceholder: t('visitor_analytics:search_by_ip_details'),
    filters: Filters().Blocked.filters,
    appliedFilters: Filters().Blocked.appliedFilters.filter((item) => !item.hidden),
  };

  return {
    visitorLog,
    blocked,
  };
};

export default useConfigTable;
